import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';

let supabaseInstance: SupabaseClient | null = null;

export function createClient(): SupabaseClient {
  if (supabaseInstance) return supabaseInstance;

  console.log('[SupabaseClient] Creating new client instance');
  console.log('[SupabaseClient] URL exists:', !!process.env.NEXT_PUBLIC_SUPABASE_URL);
  console.log('[SupabaseClient] Anon key exists:', !!process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY);

  supabaseInstance = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        // Re-enable auto refresh so valid sessions stay alive.
        // The AuthContext now handles TOKEN_REFRESH_FAILED gracefully,
        // so a network failure during refresh won't crash the app.
        autoRefreshToken: true,
        // Disable URL session detection — the /auth/callback route handles
        // OAuth code exchange explicitly.
        detectSessionInUrl: false,
        // Keep the session in localStorage so the user stays logged in
        // across page reloads without making a network call.
        persistSession: true,
      },
    }
  );

  console.log('[SupabaseClient] Client created successfully');
  return supabaseInstance;
}

// Reset singleton (used for sign-out to clear cached session)
export function resetClient(): void {
  supabaseInstance = null;
}
